import { render, staticRenderFns } from "./DeviceMonitorView.vue?vue&type=template&id=2f48247e"
import script from "./DeviceMonitorView.vue?vue&type=script&lang=js"
export * from "./DeviceMonitorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports